import { BikeConfig } from 'shared'
import { bikeConfigToQuery } from './utils/bike-config'
import { Store } from 'redux'

interface BikeConfigState {
  bikeConfig: BikeConfig // Replace 'any' with the actual type of bikeConfig if available
}

const historySync = (store: Store<BikeConfigState>): void => {
  let lastUrl: string | undefined
  store.subscribe(() => {
    const { bikeConfig } = store.getState()
    const newUrl =
      window.location.pathname + '?' + bikeConfigToQuery(bikeConfig)
    if (newUrl !== lastUrl) {
      window.history.replaceState({}, '', newUrl)
      lastUrl = newUrl
    }
  })
}

export default historySync
